
export default {
    regions: {
        1: 'Northeast',
        2: 'Midwest',
        3: 'South',
        4: 'West',
    }
}
